import { Link, useLocation } from 'react-router-dom';
import { Home, Target, MessageCircle, Folder, User } from 'lucide-react';
import { cn } from '@/lib/utils';

interface BottomNavProps {
  unreadCount?: number;
}

const navItems = [
  { path: '/home', icon: Home, label: 'Inicio' },
  { path: '/matching', icon: Target, label: 'Matching' },
  { path: '/messages', icon: MessageCircle, label: 'Mensajes', showBadge: true },
  { path: '/projects', icon: Folder, label: 'Proyectos' },
  { path: '/profile', icon: User, label: 'Perfil' },
];

export function BottomNav({ unreadCount = 0 }: BottomNavProps) {
  const location = useLocation();
  const isActive = (path: string) => location.pathname === path;

  return (
    <nav
      className="fixed bottom-0 left-1/2 z-50 w-full max-w-[390px] -translate-x-1/2 border-t border-white/10 bg-[#101319]/95 pb-[env(safe-area-inset-bottom)] shadow-[0_-12px_30px_rgba(0,0,0,0.35)] backdrop-blur-xl"
      aria-label="Navegación principal"
    >
      <div className="grid h-[72px] grid-cols-5">
        {navItems.map(({ path, icon: Icon, label, showBadge }) => {
          const active = isActive(path);
          return (
            <Link
              key={path}
              to={path}
              className={cn(
                'relative flex h-full flex-col items-center justify-center gap-1 transition-colors',
                active
                  ? 'text-[#5b7cff]'
                  : 'text-[#5d6473] hover:text-[#d7dce6]'
              )}
              aria-current={active ? 'page' : undefined}
            >
              <div className={cn(
                'relative flex h-6 w-8 items-center justify-center rounded-full transition-all',
                active && 'bg-[#5b7cff]/10'
              )}>
                <Icon className="h-[18px] w-[18px]" strokeWidth={active ? 2.5 : 2} />
                {showBadge && unreadCount > 0 && (
                  <span className="absolute -top-0.5 -right-0.5 flex h-4 min-w-[16px] items-center justify-center rounded-full bg-resuena-error px-1 text-[10px] font-bold text-white leading-none">
                    {unreadCount > 99 ? '99+' : unreadCount}
                  </span>
                )}
              </div>
              <span className={cn(
                'text-[10px] font-semibold leading-none',
                active ? 'text-[#5b7cff]' : 'text-[#5d6473]'
              )}>
                {label}
              </span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
}
